const moment = require('moment');

class CartItem {
  constructor(json) {
    this.json = json;

    this.title = json.title;
    this.itemPrice = json.item_price;
    this.originalItemPrice = json.original_item_price;
    this.shippingPrice = json.shipping_price;
    this.quantity = json.quantity;
    this.productId = json.product_id;
    this.paymentMethods = json.payment_methods;
    this.eligibleSale = json.eligible_sale;
    this.lp = json.lp;
    this._links = json._links;
    this.shopName = json.shop_name;
  }

  get thumbnail() {
    return this.mainPhoto && this.mainPhoto._links.thumbnail.href;
  }

  get mainPhoto() {
    return this.json.photos[0];
  }

  get acceptsDirectCheckout() {
    return !!this.paymentMethods.direct_checkout;
  }

  get acceptsPaypal() {
    return !!this.paymentMethods.paypal;
  }

  get preferredCheckoutLink() {
    return this.directCheckoutLink || this.paypalCheckoutLink;
  }

  get directCheckoutLink() {
    if (this.acceptsDirectCheckout) {
      return this.paymentMethods.direct_checkout._links.web.href;
    }
    return null;
  }

  get paypalCheckoutLink() {
    if (this.acceptsPaypal) {
      return this.paymentMethods.paypal._links.web.href;
    }
    return null;
  }

  get saleReminderText() {
    if (this.eligibleSale) {
      const parsed = moment(this.eligibleSale.ends_at);

      return I18n.t('js.headerCart.saleReminderText', {
        percentage: this.eligibleSale.discount_percent,
        date: parsed.format('MMM D'),
        time: parsed.format('h:mma'),
      });
    }
    return null;
  }
}

module.exports = CartItem;



// WEBPACK FOOTER //
// ./javascripts/components/cart/cart_item.js